import modelBaseV2 from "../model-base-v2.model";

var ProductModelModel = {

  getModelForNewModelDisplayFlooring: function (week = '') {
    let options = {};
    if (week) {
      options.params = { week: week };
    }

    return modelBaseV2.get(`/api/model/newmodeldisplayflooring`, options);
  }

}

export default ProductModelModel;